import { render, staticRenderFns } from "./callToAction.vue?vue&type=template&id=54125994&scoped=true&"
import script from "./callToAction.vue?vue&type=script&lang=js&"
export * from "./callToAction.vue?vue&type=script&lang=js&"
import style0 from "./callToAction.vue?vue&type=style&index=0&id=54125994&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54125994",
  null
  
)

export default component.exports